// Retrieves SafetyCulture users email from local storage
// Needed in payload for some endpoints like sudo
import { oktaAuth } from "../okta";

// (aside from automatically being added in metadata by interceptor)
export const getScUserEmail = async () => {
  const userClaims = await oktaAuth.getUser();
  return userClaims.email || "";
};
